import Webphone from 'common/Webphone'
import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

export const AudioElement = () => {
    const audioElement = useRef()
    const { volume } = useSelector((state) => state.settings)

    useEffect(() => {
        Webphone.setAudioOutput(audioElement.current)
    }, [])

    useEffect(() => {
        if (audioElement.current) {
            audioElement.current.volume = 0.01 * volume
        }
    }, [volume])

    return <audio id="audioMediaElement" ref={audioElement}></audio>
}
